// extracted by mini-css-extract-plugin
module.exports = {"sales-page":"index_sales-page__14B8n","course-catalog":"index_course-catalog__3tXU5","image":"index_image__1k3Zv"};